//=============================================================================
//                       <--- Developed By Icon Team ---> 02 february 2021
//=============================================================================

// npm packages
import React, { useEffect, useContext, useState, useCallback } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import * as moment from "moment";

// custom pages
import Context from "context/context";
import mpc from "apis/mpc/mpc";
import { mpcStyles } from "./styles";
import useDebounce from "helpers/useDebounce";
import Loader from "components/Loader/Loader";
import searchIcon from "assets/img/Search_Icon.png";
import audit from "apis/audit/audit";
import access from "config/access";
import HistoryTable from "components/Table/History/HistoryTable";

// material-ui
import { Paper, CssBaseline } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Table from "components/Table/Table";
import Button from "@material-ui/core/Button";
import InputAdornment from "@material-ui/core/InputAdornment";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import Badge from "@material-ui/core/Badge";
import IconButton from "@material-ui/core/IconButton";
import MenuItem from "@material-ui/core/MenuItem";
import Dialog from "@material-ui/core/Dialog";
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';

// material-ui icons
import CloseOutlinedIcon from "@material-ui/icons/CloseOutlined";
import MenuIcon from "@material-ui/icons/Menu";
import RemoveRedEyeIcon from "@material-ui/icons/RemoveRedEye";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";
import HistoryIcon from "@material-ui/icons/History";
import { useTranslation } from 'react-i18next';
import Checkbox from "@material-ui/core/Checkbox";


// custom TextField
const CssTextField = withStyles({
  root: {
    "& label.Mui-focused": {
      color: "##D3D3D3",
    },
    "& .MuiFormLabel-root": {
      color: "#707070",
    },
    "& .MuiInputBase-input": {
      color: "#707070",
    },
    "& .MuiInput-underline:before": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#707070!important",
    },
    "& .MuiOutlinedInput-root": {
      "& fieldset": {
        borderColor: "#707070",
      },
      "&:hover fieldset": {
        borderColor: "#707070",
      },
      "&.Mui-focused fieldset": {
        borderColor: "#707070",
      },
      "&.MuiOutlinedInput-root": {
        borderRadius: 20,
      },
      marginTop: 0,
    },
  },
})(TextField);

const GlobalCss = withStyles({
  "@global": {
    ".MuiOutlinedInput-root": {
      borderRadius: 20,
      marginTop: 0,
    },
    '.MuiAutocomplete-inputRoot[class*="MuiOutlinedInput-root"]': {
      padding: 0,
    },
  },
})(() => null);

export default function Locations(props) {
  const { state, dispatch } = useContext(Context);
  const { getMpcMajor, getMpcMinorByMajor, getMpcByMajorAndMinor, mpcMassupdate } = mpc();
  const { getAudit } = audit();

  const classes = mpcStyles();

  const [mpcMassData, setMpcMassData] = useState([]);
  const [mpcMassDataClone, setMpcMassDataClone] = useState([]);
  const [mpcMajorData, setMpcMajorData] = useState([]);
  const [mpcMinorData, setMpcMinorData] = useState([]);
  const [selectedMajor, setSelectedMajor] = useState('');
  const [selectedMinor, setSelectedMinor] = useState('');
  const [isActive, setIsActive] = useState(true);

  const [salesCategory, setSalesCategory] = useState([]);
  const [org, setOrg] = useState([]);
  const [offset, setOffset] = useState(1);
  const [count, setCount] = useState(0);
  const [filterCard, setFilterCard] = useState(false);
  const [selectedOrg, setSelectedOrg] = useState({});
  const [selectedSales, setSelectedSales] = useState({});
  const [response, setResponse] = useState({
    filter: false,
  });
  const [searchValue, setSearchValue] = useState("");
  const searchBounceValues = useDebounce(searchValue);
  const [isLoading, setIsLoading] = useState(false);
  const[selectedHead,setSelectedHead] =  useState(false);;
  const[selectedHead1,setSelectedHead1] =  useState(false);;
  const { t, i18n } = useTranslation();
  const [states, setstates] = useState({
    filter: false,
    salesCategory: "",
    redemptionFrom: null,
    redemptionTo: null,
    orgName: "",
    isActive: "",
    allowPoints: "",
    allowTier: "",
    historyLoader: false,
  });

  const setStates = useCallback((newState) => {
    setstates((states) => ({ ...states, ...newState }));
  }, []);

  const { historyLoader } = states;

  const history = useHistory();
  const location = useLocation();

  // For bread-crumbs
  useEffect(() => {
    dispatch({
      type: "SET_PATHNAME",
      payload: ["HOME", "ADMIN", "Product Exclusion / Inclusion"],
    });
  }, []);

  // handling api calls
  useEffect(() => {
    if (state.userInfo && Object.keys(state.userInfo).length > 0) {
      handleGetMpcMajor();
    }
  }, [state.userInfo]);

  useEffect(() => {
    if (selectedMajor!=='') {
      handleGetMpcMinor(selectedMajor.primary_major_class_code);
      // console.log(mpcMassData,"setCustomerData",selectedMinor)
      if(selectedMinor!==''){

        handleGetMpcMajorAndMinor(selectedMajor.primary_major_class_code,selectedMinor?.primary_minor_class_code);
      }
    }
    setSelectedHead(false)
  }, [selectedMajor,selectedMinor]);  

  // mpc major api func
  const handleGetMpcMajor = async () => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getMpcMajor();
      if (res) {
        setMpcMajorData(res.data);
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } 
    catch (e) {
      console.log({ e });
    }
  };

  // mpc minor api func
  const handleGetMpcMinor = async (major_id) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getMpcMinorByMajor(major_id);
      if (res) {
        setMpcMinorData(res?.filterData);
        if(selectedMinor==''){     
          setMpcMassData(res.data.map((d) => {
            return {
              ...d,
              selected: false              
            };
          }));
          setMpcMassDataClone(res.data.map((d) => {
            return {
              ...d,
              selected: false              
            };
          }));
        }        
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } 
    catch (e) {
      console.log({ e });
    }
  };

  // mpc mass api func
  const handleGetMpcMajorAndMinor = async (major_id,minor_id) => {
    try {
      dispatch({ type: "SET_LOADING", payload: true });
      let res = await getMpcByMajorAndMinor(major_id,minor_id);
      if (res) {     
        setMpcMassData(res.data.map((d) => {
          return {
            ...d,
            selected: false
          };
        }));
        setMpcMassDataClone(res.data.map((d) => {
          return {
            ...d,
            selected: false
          };
        }));        
        dispatch({ type: "SET_LOADING", payload: false });
      }
    } 
    catch (e) {
      console.log({ e });
    }
  };
  
  const handleChecked = (event, values, i) => {
    let checked = event.target.checked;   
    let allselected = mpcMassData.map((customer) => {
      if (customer.product_primary_class_id == values.product_primary_class_id) {
        customer.selected = checked;
      }      
      return customer;
    })
    setMpcMassData(
      allselected
    );
    const found = allselected.some(el => el.selected === false);
    const found1 = allselected.some(el => el.selected === true);
    setSelectedHead(!found)
    setSelectedHead1(found1)
    if (!checked) {
      setMpcMassData([
        ...mpcMassData.slice(0, i),
        { ...mpcMassDataClone[i] },
        ...mpcMassData.slice(i + 1),
      ]);
    }
  };

  const handleUpdate = async () =>{
    let selectedMpc = mpcMassData.filter((item) => item.selected)
    if(selectedMpc.length>0){      
      // console.log(selectedMpc,"selectedMpc");
      let seletedMpcdata = {
        updatedItems:selectedMpc,
        updatedStatus:isActive
      };
      let res = await mpcMassupdate(seletedMpcdata);
      if(res){
    setSelectedHead(false)

        toast.success("Selected data updated successfully");
        if(selectedMinor!==''){
          handleGetMpcMajorAndMinor(selectedMajor.primary_major_class_code,selectedMinor?.primary_minor_class_code);
        }
        else{
          handleGetMpcMinor(selectedMajor.primary_major_class_code);
        }
      }
      else{
        toast.error("No respose from API!");
      }
      return;
    }
    else{
      toast.error("Please select atleast one item!");
    }
  }
  
  const tableHeading = [
    "MPC ID",
    "MPC Description",
    "Sales Category",
    "Redemption %",
    "Org name",
    "Status"
  ];
  

  return (
    <React.Fragment>
      <div className={classes.mainDiv}>
        <CssBaseline />
        <Paper className={classes.root}>
          <Grid container alignItems="flex-start" spacing={2} className={classes.filterDiv}>
            <Grid container spacing={2}>  
              <Grid item xs={12}>
                <div className={classes.createLA}> {t('Product Exclusion / Inclusion')}</div>
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  id="major-select"
                  options={mpcMajorData}
                  getOptionLabel={(option) => t(option.primary_major_class_code)}
                  value={selectedMajor}
                  onChange={(event, newValue,reason) => {
                    if (reason === "clear") {
                      setMpcMassData([]);
                    setSelectedMajor('');
                    setMpcMinorData([])
                    setSelectedMinor('');

                      return;
                    }
                    setSelectedMajor(newValue);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t('Primary Major Class Code')}
                      fullWidth
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} sm={4} lg={4}>
                <Autocomplete
                  id="minor-select"
                  options={mpcMinorData}
                  getOptionLabel={(option) => t(option.primary_minor_class_code==''?'blank':option.primary_minor_class_code)}
                  value={selectedMinor}
                  onChange={(event, newValue,reason) => {
                    if (reason === "clear") {
                      setSelectedMinor('')
                      return;
                    }
                    if(newValue.primary_minor_class_code==''){
                      newValue.primary_minor_class_code = 'blank';
                   
                    }
                    // console.log(newValue,"newValue")
                    setSelectedMinor(newValue);              
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={t('Primary Minor Class Code')}
                      fullWidth
                    />
                  )}
                />
              </Grid>
            </Grid>
            <Grid container spacing={2} style={{ marginTop: 22 }}>
              <Grid item xs={12} sm={4} lg={4}>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  defaultValue={true}
                  name="radio-buttons-group"
                  row
                  value={isActive}
                  onChange={(e) => {
                    setIsActive(!isActive);
                  }}
                >
                  <FormControlLabel value={true} control={<Radio color="primary" />} label="Active" />
                  <FormControlLabel value={false} control={<Radio color="primary" />} label="In-Active" />
                </RadioGroup>
              </Grid>
              <Grid item xs={12} sm={4} lg={4} className={classes.submitBtnGrid}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  className={classes.btn}
                  disabled={!selectedHead1}
                  onClick={()=>{
                    if (!selectedMajor) {
                      toast.error("Please Select Major Class Code", {
                        toastId: "fields-empty",
                      });
                      return;
                    }
                    handleUpdate()
                  }}
                >
                  {t('Update')}
                </Button>
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </div>
      <Loader Loading={state.loading} top={"15%"}>
        <Grid container style={{ marginTop: 22 }}>
          <Grid item xs={12} sm={12} lg={12}>
            <div className={classes.tableDiv}>
              <Table
                headings={[
                  [<Checkbox
                  color="primary"
                  onChange={(event) => {
                    let checked = event.target.checked;
                    setSelectedHead(checked)
                    setSelectedHead1(checked)
                    setMpcMassData(
                      mpcMassData.map((data) => {
                        data.selected = checked;
                        return data;
                      })
                    );
                  }}
                  checked={selectedHead}
                />],
                "MPC ID",
                "MPC Description",
                "Sales Category",
                "Redemption %",
                "Org name",
                "Status"
                ]
                  
                //   tableHeading.map((i) => (
                //   <div key={t(i)}
                //     className={i === "Org name" ? classes.orgNameColumn : null}
                //   >
                //     {t(i)}
                //   </div>
                // ))
              
              }
                data={mpcMassData.map((p, i) => [
                  [
                   
                      <Checkbox
                        key={i}
                        color="primary"
                        onChange={(event) => {
                          handleChecked(event, p, i);
                        }}
                        checked={p.selected}
                      />
                  
                  ],
                  p?.product_primary_class_id,
                  p?.product_primary_class_description,
                  t(p?.loyalty_category_code),
                  p?.redemption_percentage,
                  t(p?.loyalty_organization_name),
                  [
                    p?.["is_active"] ? (
                      <span style={{ color: "green" }} key={i}>
                        {t('Active')}
                      </span>
                    ) : p?.["is_active"] != null ? (
                      <span style={{ color: "red" }} key={i}>
                        {t('InActive')}
                      </span>
                    ) : null,
                  ]
                ])}
                disablePagination={true}
              />
            </div>
          </Grid>
        </Grid>
      </Loader>
    </React.Fragment>
  );
}
